import { create } from 'zustand';

export enum SubscriptionNotActiveVariant {
  Expired = 'expired',
  NotRegistered = 'notRegistered',
}

type SubscriptionState = {
  setIsSubscriptionActive: (props: { isActive: boolean; isRegistered?: boolean }) => void;
  isSubscriptionActive: boolean;
  variant: SubscriptionNotActiveVariant;
};

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  isSubscriptionActive: true,
  setIsSubscriptionActive: ({ isActive, isRegistered }) =>
    set({
      isSubscriptionActive: isActive,
      variant: !isRegistered
        ? SubscriptionNotActiveVariant.NotRegistered
        : SubscriptionNotActiveVariant.Expired,
    }),
  variant: SubscriptionNotActiveVariant.Expired,
}));
